import { FC, MouseEventHandler } from 'react';
import { FormattedMessage, useIntl } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import { handleLocaleUrl } from 'dibs-intl/exports/urls';

const learnMoreCopy = (
    <FormattedMessage id="PdpSharedBuyerIncentivesLink.learnMore" defaultMessage="Learn More" />
);

type CommonProps = {
    className?: string;
};

export type ConditionalProps =
    | {
          variant?: 'button';
          onClick: MouseEventHandler;
      }
    | {
          variant?: 'link';
          onClick?: MouseEventHandler;
      };

export const PdpSharedBuyerIncentivesLink: FC<CommonProps & ConditionalProps> = ({
    variant = 'link',
    onClick,
    className,
}) => {
    const intl = useIntl();

    if (variant === 'button') {
        if (!onClick) {
            throw new Error(
                'onClick is required for button variant in PdpSharedBuyerIncentivesLink'
            );
        }

        return (
            <Link onClick={onClick} className={className}>
                {learnMoreCopy}
            </Link>
        );
    } else if (variant === 'link') {
        return (
            <Link
                href={handleLocaleUrl('/about/ourpromise/', intl.locale)}
                target={'_blank'}
                onClick={onClick}
                className={className}
            >
                {learnMoreCopy}
            </Link>
        );
    }

    return null;
};
